import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import Parser from 'html-react-parser';
import removeImages from './removeImagens';
import { useDevice } from 'components/DeviceContext.js';

const LerNoticia = () => {
  const { noticiaId } = useParams();
  const navigate = useNavigate();
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isMobile, isLaptop } = useDevice();

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        const { data } = await axios.get(`https://cnm.org.br/api/noticias/${noticiaId}`);
        const noticiaData = data?.noticia || null;

        if (noticiaData?.imagem && !noticiaData.imagem.startsWith('http')) {
          noticiaData.imagem = `https://cnm.org.br${noticiaData.imagem}`;
        }

        setNoticia(noticiaData);
      } catch (err) {
        console.error("Erro ao buscar notícia:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNoticia();
  }, [noticiaId]);

  const handleBack = () => navigate(-1);

  const handleShareTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        noticia.titulo
      )}&url=${encodeURIComponent(window.location.href)}`
    );
  };

  const handleShareInstagram = () => window.open(`https://www.instagram.com/`);

  const handleShareWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(noticia.titulo)}%20${encodeURIComponent(
        window.location.href
      )}`
    );
  };

  const handleShareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        window.location.href
      )}&quote=${encodeURIComponent(noticia.titulo)}`
    );
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          width: 40, height: 40,
          border: "3px solid #ddd",
          borderTopColor: "#666",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
      </div>
    );
  }

  if (!noticia) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <h2>Notícia não encontrada</h2>
      </div>
    );
  }

  const description = removeImages(noticia.conteudo, 0).substring(0, 150);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      padding: isMobile ? "16px" : "48px 64px",
      background: "#fff"
    }}>
      <Helmet>
        <title>{noticia.titulo}</title>
        <meta property="og:title" content={noticia.titulo} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={noticia.imagem || ""} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Button
          onClick={handleBack}
          startIcon={<ArrowBackIcon />}
          variant="outlined"
          size={isMobile ? "small" : "medium"}
          style={{ textTransform: "none", borderRadius: 12 }}
        >
          Voltar
        </Button>

        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{ fontSize: 14, opacity: 0.8 }}>Compartilhar:</span>
          <Button onClick={handleShareTwitter}><TwitterIcon fontSize="small" /></Button>
          <Button onClick={handleShareFacebook}><FacebookIcon fontSize="small" /></Button>
          <Button onClick={handleShareInstagram}><InstagramIcon fontSize="small" /></Button>
          <Button onClick={handleShareWhatsApp}><WhatsAppIcon fontSize="small" /></Button>
        </div>
      </div>

      <h1 style={{
        margin: 0,
        fontSize: isMobile ? 24 : isLaptop ? 26 : 28,
        fontWeight: 600,
        lineHeight: 1.3,
        textAlign: "center",
      }}>
        {noticia.titulo}
      </h1>

      {noticia.imagem && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={noticia.imagem}
            alt={noticia.titulo}
            style={{
              maxWidth: "100%",
              maxHeight: "360px",
              borderRadius: "12px",
              objectFit: "cover",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)"
            }}
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        </div>
      )}

      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        fontSize: 14,
        color: "#666"
      }}>
        {noticia.datetime && <span>{noticia.datetime}</span>}
        {noticia.data && <span style={{ opacity: 0.7 }}>{noticia.data}</span>}
      </div>

      <div style={{
        textAlign: "justify",
        lineHeight: 1.7,
        color: "#222",
        maxWidth: "860px",
        margin: "0 auto"
      }}>
        {Parser(removeImages(noticia.conteudo, 0))}
      </div>
    </div>
  );
};

export default LerNoticia;
